export default {
    CATEGORY(state, items) {
        state.items = items
    }
}